import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useTabState = (defaultTab = '') => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const urlTab = params.get('tab') || defaultTab;

  const [selectedTab, setSelectedTab] = useState(urlTab);
  const selectedTabRef = useRef(selectedTab);

  useEffect(() => {
    if (selectedTabRef.current !== urlTab) {
      selectedTabRef.current = urlTab;
      setSelectedTab(urlTab);
    }
  }, [urlTab]);

  const handleTabChange = (event, newValue) => {
    if (selectedTabRef.current !== newValue) {
      selectedTabRef.current = newValue;
      setSelectedTab(newValue);
      params.set('tab', newValue);
      const newUrl = `${location.pathname}?${params.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }
  };

  return { selectedTab, setSelectedTab, handleTabChange };
};

export default useTabState;
